import React from 'react'
import { Box, Typography } from '@mui/material'
import { TFOQuoteOfferScreenProps } from '../types'
import Checkbox from '../../../../../components/Checkbox'
import { colors } from '../../../../../themes/colors'
import TestIds from '../../../../../testIds'

interface RestrictedCheckboxProps {
  restricted: boolean
  setRestricted: TFOQuoteOfferScreenProps['setRestricted']
}

export const RestrictedCheckbox: React.FC<RestrictedCheckboxProps> = ({
  restricted,
  setRestricted,
}) => {
  return (
    <Box
      sx={{
        '@media (max-width: 744px)': {
          marginLeft: 0,
        },
      }}
    >
      <Checkbox
        checked={restricted}
        sx={{
          '.MuiCheckbox-root': {
            marginTop: '-8px',
            justifyContent: 'flex-start',
            alignContent: 'flex-start',
            alignSelf: 'flex-start',
          },
        }}
        label={
          <Typography variant='body2' fontWeight={700} sx={{ paddingLeft: '12px' }}>
            Restricted editing
            <br />
            <Typography sx={{ pt: '12px' }} variant='body2' component='span' color={colors.grey800}>
              Limit shareholder to{' '}
              <Typography variant='body2' component='span' fontWeight={700} color={colors.grey800}>
                only increase
              </Typography>{' '}
              the quantity of products (they won&apos;t be able to remove products).
            </Typography>
          </Typography>
        }
        onChange={(_, checked) => setRestricted(checked)}
        data-testid={TestIds.feat.quotes.sendOffer.lock}
      />
    </Box>
  )
}
